import { useState,useEffect,useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Alert, Box, Button, Card, CardContent, Divider, Fade, FormControl, FormControlLabel, Grid, InputLabel, List, ListItemButton, ListItemIcon, ListItemText, MenuItem, Modal, Select, Switch, TextField, Typography } from '@mui/material'
import { get, post } from '../utils/axios'
import { toast } from 'react-toastify'
import CustomButton from '../components/Button'
import { CheckCircleOutline } from '@mui/icons-material'
import CircularProgress from '@mui/material/CircularProgress'
import { Context } from '../context/Context'

import './Settings.css'

const Settings = () => {

    const { guid } = useParams()
    const navigate = useNavigate()
    const context = useContext(Context)

    const [theme,setTheme] = useState(localStorage.getItem('theme') || 'light')
    const [openModal,setOpenModal] = useState(false)
    const [openPinModal,setOpenPinModal] = useState(false)
    const [openTrackingModal,setOpenTrackingModal] = useState(false)
    const [pinCardLoading,setPinCardLoading] = useState(false)
    const [openDeposit,setOpenDeposit] = useState(false)
    const [isLoading,setIsLoading] = useState(false)
    const [amount,setAmount] = useState('')
    const [gatewayId,setGatewayId] = useState(0)
    const [gateways,setGateways] = useState([])
    const [reasons,setReasons] = useState([])
    const [reasonId,setReasonId] = useState(localStorage.getItem('reason'))
    const [preprationDays,setPreprationDays] = useState(0)
    const [trackingLoading,setTrackingLoading] = useState(false)
    const [trackData,setTrackData] = useState('')
    const [cardStatus,setCardStatus] = useState(true)
    const [changeCardStatusLoading,setChangeCardStatusLoading] = useState(true)
    const [missStatus,setMissStatus] = useState(false)
    const [approve,setApprove] = useState(false)
    const [approvePin,setApprovePin] = useState(false)

    const getMissCardData = () => {
        post('Card/ExistMissCard').then(({data}) => {
            if(data.isSuccess)
                setMissStatus(data.data.status)
        })
    }

    const missCard = () => {
        get('MissCard/InquiryRule').then(({ data }) => {
            if(data.isSuccess){
                const postedData = {
                    reasonId,
                    price: data.data.price
                }
                post('Card/MissCard',postedData).then(response => {
                    if(response.data.isSuccess){
                        getMissCardData()
                        toast.success('ثبت درخواست مفقودی کارت با موفقیت انجام شد. تحویل کارت جدید شما حداکثر تا ' + data.data.countIssueCardDay + ' روز آینده انجام می شود')
                        setOpenModal(false)
                        localStorage.removeItem('reason')
                    }else
                        toast.error(response.data.message)
                })
            }
        })
    }

    useEffect(() => {
        if(guid){
            const postedData = {
                code: guid
            }
            post('Payment/ValidateCode',postedData).then(({ data }) => {
                if(guid && data.isSuccess)
                    missCard()
                else
                    toast.error(data?.data?.message || 'پرداخت شما ناموفق بود')
            })
        }
        post('Payment/GetActiveGateway').then(({ data }) => {
            if(data.isSuccess){
                setGateways(data.data)
                setGatewayId(data.data[0].id)
            }
        })
        post('Card/StatusCard').then(({ data }) => {
            if(data.isSuccess)
                setCardStatus(data.data.statusCode == 2)
        }).finally(() => setChangeCardStatusLoading(false))
        get('MissCard/GetReason').then(({ data }) => {
            if(data.isSuccess)
                setReasons(data.data)
        })
        get('MissCard/InquiryRule').then(({ data }) => {
            if(data.isSuccess){
                setAmountValue(data.data.price)
                setPreprationDays(data.data.countIssueCardDay)
            }
        })
        getMissCardData()
    },[])

    const changeTheme = e => {
        let themeMode = e.target.value
        setTheme(themeMode)
        localStorage.setItem('theme',themeMode)
        if(themeMode == 'light' || themeMode == 'dark')
            document.body.className = themeMode
        else{
            if(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)
                document.body.className = 'dark'
            else
                document.body.className = 'light'
        }
    }

    const logout = () => {
        post('User/LogOutUser')
        localStorage.removeItem('token')
        context.setProfile({roleId: 0})
        context.setGuildId(0)
        context.setBasket([])
        context.setCards([])
        context.setAddress({})
        context.setlatitude(null)
        context.setLongitude(null)
        context.setCurrentProvinceId(0)
        context.setCurrentCityId(0)
        context.setWalletPayment(false)
        setTimeout(() => {
            navigate('/')
        },300)
    }

    const handleOpenDepositModal = () => {
        setOpenModal(false)
        setTimeout(() => {
            setAmount(new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(100000))
            setOpenDeposit(true)
        },100)
    }

    const setAmountValue = value => {
        value = value.toString().replace(/,/g,'')
        value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value)
        if(value == 'NaN')
            value = ''
        setAmount(value)
    }

    const chargeDeposit = () => {
        setIsLoading(true)
        const postedData = {
            amount: amount.toString().replace(/,/g,''),
            gatewayId,
            action: 1,
            callbackUrl: '/app/settings/'
        }
        post('Payment/GetToken',postedData).then(({ data }) => {
            if(data.isSuccess)
                window.location.href = data.data.redirectUrl
            else
                setIsLoading(false)
        }).catch((e) => {
            setIsLoading(false)
        })
    }

    const trackStatus = () => {
        setTrackingLoading(true)
        post('Card/InqueryCard').then(({data}) => {
            if(data.isSuccess){
                const result = [...data.data.sort((a,b) => b.orderId - a.orderId)]
                setTrackData(result[0])
                setOpenTrackingModal(true)
            }else
                toast.error(data.message)
        }).finally(() => setTrackingLoading(false))
    }

    const changeCardStatus = () => {
        setChangeCardStatusLoading(true)
        const url = cardStatus ? 'Card/DeActiveCard' : 'Card/ActiveCard'
        post(url).then(({data}) => {
            if(data.isSuccess){
                toast.success(cardStatus ? 'غیرفعال سازی پتروکارت با موفقیت انجام شد' : 'فعال سازی پتروکارت با موفقیت انجام شد')
                post('Card/StatusCard').then(({data}) => {
                    if(data.isSuccess)
                        setCardStatus(data.data.statusCode == 2)
                })
            }else
                toast.error(data.message)
        }).finally(() => setChangeCardStatusLoading(false))
    }

    const changePinCard = () => {
        setPinCardLoading(true)
        post('Card/ChangePin').then(({data}) => {
            if(data.isSuccess){
                toast.success('درخواست شما ثبت شد. نتیجه به زودی از طریق پیامک به اطلاع شما خواهد رسید')
                setOpenPinModal(false)
            }
        }).finally(() => {
            setPinCardLoading(false)
        })
    }

    const changeReason = id => {
        localStorage.setItem('reason',id)
        setReasonId(id)
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '92%',
        boxSizing: 'border-box',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    }

    return (
        <Grid item px={0.3}>
            <h3 className="others-page-title">تنظیمات</h3>
            <div className="safe-area">
                <Card sx={{ width: '100%',mb: 5 }} className="business-item">
                    <CardContent sx={{ py: 4,pt: 3.2 }}>
                        <Button fullWidth sx={{ mb: 4,py: 1.2 }} color="inherit" variant="outlined" startIcon={<i className="fal fa-location-dot"></i>} onClick={() => navigate('/app/profile/addresses')}>آدرس های من</Button>
                        <FormControl fullWidth>
                            <InputLabel id="app-theme-label">ظاهر اپلیکیشن</InputLabel>
                            <Select labelId="app-theme-label" id="app-theme" value={theme} label="ظاهر اپلیکیشن" onChange={changeTheme}>
                                <MenuItem value="light">روشن</MenuItem>
                                <MenuItem value="dark">تیره</MenuItem>
                                <MenuItem value="device">حالت دستگاه</MenuItem>
                            </Select>
                        </FormControl>
                        {context.profile.roleId != 103 ? (missStatus ? <CustomButton fullWidth sx={{ mt: 2.5,py: 1.2 }} isLoading={trackingLoading} color="inherit" variant="outlined" startIcon={<i className="fal fa-credit-card"></i>} onClick={trackStatus}>پیگیری مفقودی کارت</CustomButton> : <Button fullWidth sx={{ mt: 3,py: 1.2 }} color="inherit" variant="outlined" startIcon={<i className="fal fa-credit-card"></i>} onClick={() => setOpenModal(true)}>ثبت درخواست صدور مجدد کارت</Button>) : ''}
                        {context.profile.roleId != 103 && !missStatus ? <Button fullWidth sx={{ mt: 2.5,py: 1.2 }} color={cardStatus ? 'error' : 'success'} variant="outlined" startIcon={<i className="fal fa-credit-card"></i>} onClick={changeCardStatus} disabled={changeCardStatusLoading}>{changeCardStatusLoading ? <CircularProgress size={21} /> : (cardStatus ? 'غیرفعال سازی کارت' : 'فعال سازی کارت')}</Button> : ''}
                        {context.profile.roleId != 103 ? <Button fullWidth sx={{ mt: 3,py: 1.2 }} color="inherit" variant="outlined" startIcon={<i className="fal fa-key"></i>} onClick={() => setOpenPinModal(true)}>تغییر رمز کارت</Button> : ''}
                        <Button fullWidth sx={{ mt: 2.5,py: 1.2 }} color="inherit" variant="outlined" startIcon={<i className="fal fa-power-off"></i>} onClick={logout}>خروج</Button>
                    </CardContent>
                </Card>
            </div>
            <Modal open={openModal} onClose={() => setOpenModal(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Fade in={openModal}>
                    <Box sx={style}>
                        <Typography variant="h6" component="h2" sx={{ fontSize: 18 }}>درخواست صدور مجدد کارت</Typography>
                        <Divider sx={{mt: 2,mb: 2.5}} />
                        <div id="miss-card-modal">
                            <p>لطفاً توجه داشته باشید، با ثبت درخواست مفقودی <span>پتروکارت فعلی شما مسدود (ابطال) می شود</span> و تا زمان دریافت پتروکارت جدید امکان استفاده از پتروکارت خود را نخواهید داشت</p>
                            <p>مدت زمان صدور پتروکارت جدید شما <span>{preprationDays}</span> روز کاری می باشد</p>
                            <p className="op-price-detail">جهت ثبت درخواست صدور مجدد پتروکارت، ملزم به پرداخت مبلغ <span>{amount}</span> ریال خواهید بود</p>
                            <FormControlLabel sx={{mt: 1}} control={<Switch checked={approve} onChange={() => setApprove(!approve)} />} label="موارد بالا را خوانده ام و قبول دارم" />
                            {/* {deposit >= 100000 ? <CustomButton fullWidth isLoading={missCardLoading} variant="contained" color="primary" sx={{py: 1.5,mt: 1}} disabled={!approve} onClick={missCard}>ثبت درخواست مفقودی</CustomButton> : ''} */}
                            {/* {deposit < 100000 && approve ? <p>موجودی کیف پول نقدی شما برای ثبت درخواست مفقودی کافی نمی باشد. لطفاً ابتدا کیف پول خود را به مبلغ <span>{new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(Math.abs(100000 - deposit))}</span> ریال شارژ کنید</p> : ''} */}
                            {approve ? <>
                                <FormControl fullWidth sx={{mt: 5}}>
                                    <InputLabel id="reason-label">علت</InputLabel>
                                    <Select labelId="reason-label" id="reason" value={reasonId} label="علت" onChange={e => changeReason(e.target.value)}>
                                        {reasons.map(reason => <MenuItem key={reason.id} value={reason.id}>{reason.title}</MenuItem>)}
                                    </Select>
                                </FormControl>
                                <Button variant="outlined" fullWidth color="secondary" sx={{py: 1.5,mt: 1.5}} onClick={handleOpenDepositModal}>تایید و ادامه</Button>
                            </> : ''}
                        </div>
                    </Box>
                </Fade>
            </Modal>
            <Modal open={openPinModal} onClose={() => setOpenPinModal(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Fade in={openPinModal}>
                    <Box sx={style}>
                        <Typography variant="h6" component="h2" sx={{ fontSize: 18 }}>تغییر رمز کارت</Typography>
                        <Divider sx={{mt: 2,mb: 2.5}} />
                        <div id="miss-card-modal">
                            <p>لطفاً توجه داشته باشید که با ثبت درخواست تغییر رمز، <span>رمز فعلی پتروکارت شما تغییر می کند</span> و تا دریافت رمز جدید که از طریق پیامک برای شما ارسال خواهد شد، امکان استفاده از پتروکارت خود را نخواهید داشت</p>
                            <FormControlLabel sx={{mt: 1}} control={<Switch checked={approvePin} onChange={() => setApprovePin(!approvePin)} />} label="موارد بالا را خوانده ام و قبول دارم" />
                            <CustomButton fullWidth isLoading={pinCardLoading} variant="contained" color="primary" sx={{py: 1.5,mt: 1}} disabled={!approvePin} onClick={changePinCard}>ثبت درخواست تغییر رمز</CustomButton>
                        </div>
                    </Box>
                </Fade>
            </Modal>
            <Modal open={openTrackingModal} onClose={() => setOpenTrackingModal(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Fade in={openTrackingModal}>
                    <Box sx={style}>
                        <Typography variant="h6" component="h2" sx={{ fontSize: 18 }}>پیگیری مفقودی شناسه {trackData.orderId}</Typography>
                        <Divider sx={{mt: 2,mb: 2.5}} />
                        <Alert variant="standard" color="info">وضعیت فعلی درخواست: {trackData.statusTitle}</Alert>
                    </Box>
                </Fade>
            </Modal>
            <Modal open={openDeposit} onClose={() => setOpenDeposit(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Fade in={openDeposit}>
                    <Box sx={style}>
                        <Typography variant="h6" component="h2" sx={{ fontSize: 18 }}>پرداخت هزینه مفقودی کارت</Typography>
                        <TextField type="tel" className="ltr-input" sx={{mb: 3,mt: 2}} fullWidth={true} inputProps={{maxLength: 12}} label="مبلغ" variant="standard" value={amount} onChange={e => setAmountValue(e.target.value)} disabled />
                        <Typography variant="subtitle2" component="span" className="choose-gateway-title">انتخاب درگاه پرداخت</Typography>
                        <List component="nav">
                            {gateways.map((gateway,index) => <ListItemButton key={gateway.id} selected={index == 0} onClick={() => setGatewayId(gateway.id)}>
                                <img src={gateway.logo} width={60} style={{ marginLeft: 10 }} />
                                <ListItemText>{gateway.title}</ListItemText>
                                {gatewayId == gateway.id ? <ListItemIcon sx={{ minWidth: 'unset' }}>
                                    <CheckCircleOutline color="success" />
                                </ListItemIcon> : ''}
                            </ListItemButton>)}
                        </List>
                        <CustomButton type="submit" isLoading={isLoading} fullWidth={true} sx={{mt: 1,py: 1.5}} className="custom-btn-primary" variant="contained" disabled={!amount || amount.length < 6 || amount.toString().replace(/,/g,'') < 100000} onClick={chargeDeposit}>پرداخت و ثبت مفقودی</CustomButton>
                    </Box>
                </Fade>
            </Modal>
        </Grid>
    )
}

export default Settings